
// import feathersClient from '../services/feathers-connection';
// import { Pagination } from 'antd';
// import React, {useEffect, useState} from 'react';
// import ContactTable from '../components/account/ContactTable';
// import Headline from '../components/account/Headline';
// import styled from 'styled-components';
// import { Button } from '@bootstrap-styled/v4';
// import { Box } from '@material-ui/core';

// const DidPagination = styled.p`
//   display:flex;
//   justify-content:flex-end;
//   align-items:center;
//   width:100%;
// `;

// const MyContactAccount = () => {
//   const [contacts, setContacts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [loadReport, setLoadReport] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pagination, setPagination] = useState({
//     total: 0,
//     limit: 10,
//     skip: 0
// })

//   const getService = async (...args) => {
//     // console.log(args)
//     const res = await feathersClient.service('contact-projects').find(...args)
//     return res
//   }

//   const report = () => {
//     setLoadReport(true)
//     getService({ query: { $client: { report: 'true', } } })
//     .then((res) => { 
//       window.open(res.url, '_blank')
//       setLoadReport(false)
//     })
//   }

//   const fetchPagination = (skip) => {
//     getService({ query: {
//         $skip: skip,
//         $limit: pagination.limit,
//     } }).then(res => {
//       setPagination({
//         limit: res.limit,
//         skip: res.skip || 0,
//         total: res.total
//     })
//     setContacts(res)
//     })
//   }

// useEffect(() => {
//   setLoading(true);
//   getService({ query: {  $skip: 0, $limit: 10}})
//   .then(res => {
//     setPagination({
//       limit: res.limit,
//       skip: res.skip || 0,
//       total: res.total
//   })
//     setLoading(false) 
//     setContacts(res)
//   })
//   .catch(error => console.log(error))
// }, []);

//   return (
//     <React.Fragment>
//       <Box display='flex' justifyContent='space-between' mb={2} >
//       <Headline title="Contactos" />
//       <Button onClick={report}>{ loadReport ? 'generando...' : 'generar reporte'}</Button>
//       </Box>
//       <ContactTable loading={loading} contacts={contacts.data} />
//       <DidPagination>
//         <Pagination
//           current={currentPage}
//           pageSize={pagination.limit} 
//           total={pagination.total} 
//           onChange={ (page, pageSize) => {
//             fetchPagination((page - 1) * pageSize)
//             setCurrentPage(page)
//           }} 
//           />
//         </DidPagination>
//     </React.Fragment>
//   );
// };

// export default MyContactAccount;

import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Pagination} from 'antd';
import {Button} from '@bootstrap-styled/v4';
import {Box} from '@material-ui/core';
import feathersClient from '../services/feathers-connection';
import ContactTable from '../components/account/ContactTable';
import Headline from '../components/account/Headline';

const DidPagination = styled.p`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;

const MyContactAccount = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadReport, setLoadReport] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [pagination, setPagination] = useState({
    total: 0,
    limit: 10,
    skip: 0,
  });
  const [exportingCSV, setExportingCSV] = useState(false);

  const getService = async (...args) => {
    const res = await feathersClient.service('contact-projects').find(...args);
    return res;
  };

  const fetchFilteredContacts = () => {
    setLoading(true);
    getService({
      query: {
        $skip: 0,
        $limit: pagination.limit,
        ...(startDate && endDate
          ? {
              createdAt: {
                $gte: startDate,
                $lte: endDate,
              },
            }
          : {}),
      },
    })
      .then(res => {
        setContacts(res);
        setPagination({
          limit: res.limit,
          skip: res.skip || 0,
          total: res.total,
        });
        setCurrentPage(1);
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
        setLoading(false);
      });
  };

  const fetchPagination = skip => {
    getService({
      query: {
        $skip: skip,
        $limit: pagination.limit,
        ...(startDate && endDate
          ? {
              createdAt: {
                $gte: startDate,
                $lte: endDate,
              },
            }
          : {}),
      },
    }).then(res => {
      setContacts(res);
      setPagination({
        limit: res.limit,
        skip: res.skip || 0,
        total: res.total,
      });
    });
  };

  const report = () => {
    setLoadReport(true);
    getService({
      query: {
        $client: {
          report: 'true',
          startDate,
          endDate,
        },
        $order: {},
      },
    })
      .then(res => {
        window.open(res.url, '_blank');
        setLoadReport(false);
      })
      .catch(() => {
        setLoadReport(false);
      });
  };

  const downloadCSV = async () => {
    try {
      const res = await getService({
        query: {
          $limit: 10000,
          ...(startDate && endDate
            ? {
                createdAt: {
                  $gte: startDate,
                  $lte: endDate,
                },
              }
            : {}),
        },
      });
  
      const data = res.data || [];
  
      if (data.length === 0) {
        alert("No hay datos para exportar.");
        return;
      }
  
      const formatDate = dateStr => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };
  
      const baseHeaders = Object.keys(data[0])
        .filter(key => !["deletedAt", "updatedAt", "createdAt", "project", "construction_company"].includes(key) && key !== "id");
  
      const headers = [
        "id",
        "construction_company_name",
        "fecha",
        ...baseHeaders,
        "project_name"
      ];
  
      const csv = [
        headers.join(","),
        ...data.map(row => {
          return headers
            .map(field => {
              if (field === "id") return row.id;
              if (field === "construction_company_name") return row.project?.construction_company?.name || "";
              if (field === "fecha") return formatDate(row.createdAt);
              if (field === "project_name") return row.project?.name || "";
              return `"${String(row[field] ?? "").replace(/"/g, '""')}"`;
            })
            .join(",");
        }),
      ].join("\r\n");
  
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "contactos.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Error al generar CSV:", err);
    }
  };

  useEffect(() => {
    setLoading(true);
    getService({
      query: {
        $skip: 0,
        $limit: 10,
      },
    })
      .then(res => {
        console.log({res})
        setContacts(res);
        setPagination({
          limit: res.limit,
          skip: res.skip || 0,
          total: res.total,
        });
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  return (
    <React.Fragment>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Headline title="Contactos" />
        <Button onClick={report}>
          {loadReport ? 'Generando...' : 'Generar reporte'}
        </Button>
      </Box>

      <div style={{display:"flex", marginBottom:"1rem", justifyContent:"center", gap: "1rem"}}>
        <div>
          <label>Desde:</label>
          <br />
          <input
            type="date"
            value={startDate}
            onChange={e => setStartDate(e.target.value)}
          />
        </div>
        <div>
          <label>Hasta:</label>
          <br />
          <input
            type="date"
            value={endDate}
            onChange={e => setEndDate(e.target.value)}
          />
        </div>
        <div style={{alignSelf: 'flex-end'}}>
          <Button onClick={fetchFilteredContacts}>Filtrar</Button>{' '}
          <Button 
            className="me-3"
            onClick={downloadCSV}
            style={{marginLeft: '0.5rem'}}
            disabled={exportingCSV}>
            {exportingCSV ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"></span>
                <span className="ms-2">Exportando...</span>
              </>
            ) : (
              'Descargar CSV'
            )}
          </Button>
        </div>
      </div>

      <ContactTable loading={loading} contacts={contacts.data || []} />

      <DidPagination>
        <Pagination
          current={currentPage}
          pageSize={pagination.limit}
          total={pagination.total}
          onChange={(page, pageSize) => {
            fetchPagination((page - 1) * pageSize);
            setCurrentPage(page);
          }}
        />
      </DidPagination>
    </React.Fragment>
  );
};

export default MyContactAccount;